import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import get from 'lodash/get';
import useMutation from '../../modules/react/hooks/useMutation';
import PageDeleteModal from '../components/PageDeleteModal';

const DELETE_PAGES = gql`
  mutation PageDelete($ids: [String!]) {
    pageDelete(ids: $ids) {
      pages {
        id
        title
      }
      userErrors {
        code
        message
      }
    }
  }
`;

const propTypes = {
  onDismiss: PropTypes.func.isRequired,
  page: PropTypes.shape({
    id: PropTypes.string.isRequired,
    children: PropTypes.arrayOf(
      PropTypes.shape({
        pageId: PropTypes.string.isRequired,
        locale: PropTypes.string.isRequired,
      }),
    ),
  }).isRequired,
  show: PropTypes.bool.isRequired,
  search: PropTypes.func.isRequired,
};
const defaultProps = {};

const PageDeleteModalContainer = ({ onDismiss, page, show, search }) => {
  const [
    deletePages, { data, error, loading },
  ] = useMutation(DELETE_PAGES);

  const onSubmit = async (pages) => {
    await deletePages({
      variables: {
        siteId: pages.map(pageToDelete => pageToDelete.siteId),
        ids: pages.map(pageToDelete => pageToDelete.id || pageToDelete.pageId),
      },
    });

    search();
  };

  if (!show) {
    return null;
  }

  return (
    <PageDeleteModal
      onDismiss={onDismiss}
      onSubmit={onSubmit}
      page={page}
      show={show}
      loading={loading}
      submitErrors={[error].filter(err => err != null)}
      pagesDeleted={get(data, 'pageDelete.pages', [])}
    />
  );
};

PageDeleteModalContainer.propTypes = propTypes;
PageDeleteModalContainer.defaultProps = defaultProps;

export default PageDeleteModalContainer;
